
const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu("custom/bipai/BiPaiSeatGenPaiView")
export default class BiPaiSeatGenPaiView extends cc.Component{

    @property(cc.Node)
    nodeGenPaiParent: cc.Node = null

    @property([cc.Node])
    nodeGenPaiPrefabList: cc.Node[] = []

    protected m_nodeBomb: cc.Node = null

    protected ensureInitedNode(node: cc.Node, prefab: cc.Node, parent: cc.Node): cc.Node{
        let newNode = node || cc.instantiate(prefab)
        newNode.parent = parent
        newNode.position = cc.Vec2.ZERO
        return newNode
     }

    playGenPaiAnim(count: number, delay?: number, onFinish?: Function){
        let self = this
        let deal_fun = function(){
            let nodeParent = self.nodeGenPaiParent
            let node = cc.instantiate(self.nodeGenPaiPrefabList[count - 1])
            node.parent = nodeParent            
            node.position = cc.Vec2.ZERO
            node.active = true
            self.scheduleOnce(function(){
                node.destroy()
                onFinish && onFinish()
            }, 1.5)
        }
        if(delay){
            self.scheduleOnce(function(){
                deal_fun()
            }, delay)
        }else{
            deal_fun()
        }
    }

    protected checkAndDealCallback(node: cc.Node){
        let self = this
        let lastFun = self.getNodeActionCallback(node)            
        if(lastFun){            
            lastFun()
            return self.checkAndDealCallback(node)
        }  
    }

    protected setNodeActionCallback(node: cc.Node, callback: Function){
        node['_action_callback'] = callback
    }    

    protected getNodeActionCallback(node: cc.Node){
        return node['_action_callback']
    }
}
